<template>
  <div>
    <el-card>
      <el-form :model="form" :rules="{}" style="width: 700px">
        <el-form-item :label="$t('device.payBankId') + ':'" prop="payBankId">
          <el-select v-model="form.payBankId" filterable @change="selectchange" style="width: 700px">
            <el-option v-for="item in list" :key="item.id"
              :label="`${item.bankCode}-${item.bankAccount}-${item.payName}-${item.balance}`" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.receiverNumber') + ':'" prop="receiverNumber">
          <el-select v-model="form.receiverNumber" filterable clearable  style="width: 700px" allow-create  @change="onReceiverNumberChange">
            <el-option v-for="(item, index) in receiverNumberlist" :key="index" :label="`${item.cardNumber}-${item.depositor}-${item.bankCode}`" :value="item.cardNumber">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.receiverName') + ':'" prop="receiverName">
          <el-input v-model="form.receiverName" style="width: 700px" clearable/>
        </el-form-item>
        <el-form-item :label="$t('device.receiverBankCode') + ':'" prop="receiverBankCode">
          <el-select v-model="form.receiverBankCode" filterable style="width: 700px" clearable>
            <el-option v-for="(item, index) in bankTypeList" :key="index" :label="item.bankName +'-'+ item.bankCode"
              :value="item.bankCode">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('device.amount') + ':'" prop="amount">
          <el-input v-model.trim="form.amount" style="width: 700px" clearable/>
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" :loading="confirmLoading" @click="confirm()">{{
            $t('device.confirm')
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog :title="$t('device.subotp') + ':'" :visible.sync="dialogVisible"   :modal-append-to-body="false" :close-on-click-modal="false">
      <el-form :model="'left'">
        <el-form-item :label="$t('device.payinfo')">
          {{ `${subform.receiverBankCode}-${subform.receiverName}-${subform.receiverNumber}` }}
        </el-form-item>
        <el-form-item
          :label="$t('device.paycode')"
          v-if="subform.transCode && subform.transCode.indexOf('data:image/png;base64') > -1"
        >
          <img :src="subform.transCode" style="width: 200px; margin: 0; display: block" />
        </el-form-item>
        <el-form-item :label="$t('device.transCode')" v-else>
          {{ subform.transCode }}
        </el-form-item>
        <el-form-item :label="$t('device.enterotp')" align="left">
          <el-input v-model.trim="subform.patchGoogleCode" style="width: 500px" />
        </el-form-item>
        <el-form-item>
          <el-button size="mini" type="primary" @click="submit()">{{
            $t('device.confirm')
          }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
  import merchantApi from '@/api/merchant';
  import device_API from '@/api/device';
  export default {
    name: 'bankconfirm',

    data() {
      return {
        confirmLoading:false,
        form: {
          payBankId: '',
          amount: '',
          receiverNumber: '',
          receiverName: '',
          receiverBankCode: ''
        },
        subform: {
          patchGoogleCode: ''
        },
        dialogVisible: false,
        bankTypeList: [],
        list: [],
        account: '',
        receiverNumberlist: [],
        rawReceiverList: [],
      };
    },

    mounted() {
      this.bank_draw_option();
      this.getTableData();
      this.getReceiverNumberlist();
    },

    methods: {
      async getReceiverNumberlist () {
      let param = {
        no: 1,
        size: 9999
        };
      try {
        const { data } = await merchantApi.getPayoutBanks(param);
        if (data && data.code === 200) {
          this.rawReceiverList = data.data.list;
          this.receiverNumberlist = data.data.list || [];
        } else {
          this.receiverNumberlist = [];
          this.$message.error(data.msg);
        }
      }catch (error) {
        this.receiverNumberlist = [];
        this.$message.error(error.message || 'Network error');
      }
       
      },

      onReceiverNumberChange(val) {
        const selected = this.rawReceiverList.find(item => item.cardNumber === val);
        if (selected) {
          this.form.receiverName = selected.depositor;
          this.form.receiverBankCode = selected.bankCode;
        } else {
          // 如果是手动输入的新账号，则清空其他字段
          this.form.receiverName = '';
          this.form.receiverBankCode = '';
        }
      },
      selectchange(val) {
        this.list.forEach((it) => {
          if (it.id == val) {
            console.log('account',this.account,it.bankName);
            this.account = it.bankName;
          }
        });
      },
      async bank_draw_option() {
        const {
          data
        } = await device_API.bank_draw_option();
        if (data && data.code === 200) {
          this.bankTypeList = data.data || [];
        } else {
          this.$message.error(data.msg);
        }
      },
      async getTableData() {
        const {
          data
        } = await device_API.b_listpage({
          query: {
            //银行编码
            bankCode: '',
            //设备号
            serialNumber: '',
            //银行收款账号
            bankAccount: '',
            //银行登录账号
            loginAccount: ''
          },
          no: 1,
          size: 99999999
        });
        if (data && data.code == 200) {
          this.list = data.data.list;
        }
      },
      async confirm() {
        this.confirmLoading = true;
        let param = this.form;
        param.amount = Number(param.amount);
        const {
          data
        } = await device_API.bank_draw_create(this.form);
        if (data && data.code === 200) {
          this.dialogVisible = true;
          this.subform = Object.assign({patchGoogleCode:''}, data.data);
        } else {
          this.$message.error(data.msg);
        }
        this.confirmLoading = false;
      },
      async submit() {
        let param = {
          systemOrderNo: this.subform.systemOrderNo,
          patchGoogleCode: Number(this.subform.patchGoogleCode)
        };
        const {
          data
        } = await device_API.bank_draw_confirm(param);
        if (data && data.code === 200) {
          this.dialogVisible = false;
          this.$message.success(data.msg);
        } else {
          this.$message.error(data.msg);
        }
      }
    }
  };

</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/device/bankconfirm.vue